// extracted by mini-css-extract-plugin
export default {"toolbar":"HistoryToolbar_toolbar__e8Ovq"};